import { render, staticRenderFns } from "./title-sub.vue?vue&type=template&id=6d36c0f8&scoped=true"
import script from "./title-sub.vue?vue&type=script&lang=ts"
export * from "./title-sub.vue?vue&type=script&lang=ts"
import style0 from "./title-sub.vue?vue&type=style&index=0&id=6d36c0f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d36c0f8",
  null
  
)

export default component.exports